import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { EndpointInfoClient, IEndpointInfo } from "@/Common/Api/EndpointInfoClient";
import { ExternalServiceClient } from "@/Common/Api/ExternalServiceClient";
import * as ServerOperations from "@/Common/Operations/operations.server";

/**
 * An API client which fetches and caches access info for the employee registry endpoint.
 */
class EmployeeRegistryEndpointInfoClient extends EndpointInfoClient {
    public constructor(apiVersion: string) {
        super(ServerOperations.Server.Myle_LoadBearerTokenForEmployeeReg, apiVersion);
    }

    protected async getAccessInfoFromServer(): Promise<IEndpointInfo> {
        try {
            const response = await Client.postAsync<{ BaseUri: string, Token: string, Ttl: number }>(this.operation, { apiVersion: this.apiVersion });
            const data = response.data;

            const cleanBaseUri = data.BaseUri.endsWith("/") ? data.BaseUri : `${data.BaseUri}/`;

            return {
                baseUri: cleanBaseUri,
                token: data.Token,
                ttl: data.Ttl ?? EndpointInfoClient.defaultTimeToLiveInMin,
                tokenGeneratedDateTime: moment().toDate()
            };
        }
        catch (error) {
            console.error(error);
        }
    }
}

/**
 * Client to access the employee registry service
 */
class EmployeeRegistryClient extends ExternalServiceClient {
    private static instanceV1: EmployeeRegistryClient;
    private static instanceV2: EmployeeRegistryClient;

    private constructor(apiVersion: string) {
        const endpointInfoClient = new EmployeeRegistryEndpointInfoClient(apiVersion);
        super(endpointInfoClient);
    }

    public static getInstanceV1(): EmployeeRegistryClient {
        if (!EmployeeRegistryClient.instanceV1)
            EmployeeRegistryClient.instanceV1 = new EmployeeRegistryClient("v1.0");

        return EmployeeRegistryClient.instanceV1;
    }

    public static getInstanceV2(): EmployeeRegistryClient {
        if (!EmployeeRegistryClient.instanceV2)
            EmployeeRegistryClient.instanceV2 = new EmployeeRegistryClient("v2.0");

        return EmployeeRegistryClient.instanceV2;
    }
}

export { EmployeeRegistryClient };
